import { useEffect } from 'react'
import { useQuery, useMutation } from '@tanstack/react-query'
import { api } from '../lib/api.js'

const ICONO = {
  done:    <span style={{ color: 'var(--success)' }}>✓</span>,
  running: <span className="mini-spin" />,
  failed:  <span style={{ color: 'var(--danger)' }}>✕</span>,
  skipped: <span style={{ color: 'var(--fg-3)' }}>–</span>,
  pending: <span style={{ color: 'var(--fg-3)' }}>○</span>,
}

/** Progreso del alta, paso a paso. Sondea hasta que termina o falla. */
export function Progress({ slug, onDone }) {
  const q = useQuery({
    queryKey: ['provisioning', slug],
    queryFn: () => api.provisioning(slug),
    refetchInterval: (r) => (['ready', 'failed'].includes(r.state.data?.state) ? false : 1500),
  })
  const retry = useMutation({ mutationFn: () => api.retryProvision(slug), onSuccess: () => q.refetch() })

  useEffect(() => {
    if (q.data?.state === 'ready') { const t = setTimeout(onDone, 1200); return () => clearTimeout(t) }
  }, [q.data?.state, onDone])

  const estado = q.data?.state

  return (
    <div className="card">
      <div className="card-head">
        <span className="h2" style={{ fontSize: 14 }}>
          {estado === 'ready' ? 'Proyecto listo'
            : estado === 'failed' ? 'El alta se detuvo'
            : 'Creando el proyecto…'}
        </span>
        {estado === 'failed' && (
          <button className="btn secondary sm" onClick={() => retry.mutate()} disabled={retry.isPending}>
            {retry.isPending ? 'Reintentando…' : 'Reintentar'}
          </button>
        )}
      </div>

      <div style={{ padding: '6px 0' }}>
        {(q.data?.steps ?? []).map((s) => (
          <div key={s.id} className="prov-step">
            <span className="prov-icon">{ICONO[s.state] ?? ICONO.pending}</span>
            <span style={{ color: s.state === 'pending' ? 'var(--fg-3)' : 'var(--fg)' }}>{s.titulo}</span>
            {s.error && <span className="prov-error">{s.error}</span>}
          </div>
        ))}
      </div>

      {estado === 'failed' && (
        <div className="card-pad" style={{ borderTop: '1px solid var(--border)' }}>
          <div className="alert error">{q.data.error}</div>
          <p style={{ color: 'var(--fg-2)', fontSize: 13, marginBottom: 0 }}>
            Los pasos son idempotentes: reintentar vuelve a ejecutarlos todos sin duplicar nada.
            Lo que quedó a medias lo limpia el reconciliador si el proyecto se abandona.
          </p>
        </div>
      )}

      {estado === 'ready' && q.data.domain && (
        <div className="card-pad" style={{ borderTop: '1px solid var(--border)' }}>
          <a className="btn" href={`https://${q.data.domain}`} target="_blank" rel="noreferrer">
            Abrir {q.data.domain} ↗
          </a>
          <p style={{ color: 'var(--fg-2)', fontSize: 13, margin: '12px 0 0' }}>
            El primer despliegue puede tardar un par de minutos más en estar sirviendo.
          </p>
        </div>
      )}
    </div>
  )
}
